/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  AllObjectAssignmentsResponse,
  AllowedActionsResponse,
  ApiAllowedActionsRequest,
  ApiAssignmentExportCsvRequest,
  ApiAssignmentRequest,
  ApiAssignmentResponse,
  ApiBudgetMatchesResponse,
  ApiBudgetPeriodPrepareRequest,
  ApiBudgetRecommendationsResponse,
  ApiBulkAssignmentRequest,
  ApiBulkUpdateBudgetGroupsAmountTypeRequest,
  ApiPagedAssignmentRequest,
  ApiPagedAssignmentResponse,
  ApiPagedBudgetRequest,
  ApiUpdateBudgetGroupRequest,
  ApiUpdateBudgetPeriodRequest,
  ApiUpdateBudgetResponse,
  BudgetAssignmentModeMigrationResponse,
  BudgetGroupResponse,
  BudgetPeriodResponse,
  BudgetWithSpendersAndGroupInfoAndSubBudgets,
  BudgetsWithAssignmentAmountsResponse,
  BulkAssignmentResponse,
  FetchBudgetsChartParams,
  GetAllBudgetsAssignedToParams,
  GetAllRecommendedBudgetsParams,
  GetMatchingBudgetsParams,
  GetPurchaseRequestBudgetsMatchWithSpendBudgetsParams,
  GetPurchaseRequestBudgetsMatchWithSpendBudgetsPayload,
  PaginatedResponseBudgetWithSpendersBudgetPagedMeta,
  SettingsResponse,
  UnassignFromBudgetV2Params,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiBudgetController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-budget-controller
   * @name UpdateBudgetGroup
   * @request PUT:/api/v1/budgets
   */
  updateBudgetGroup = (data: ApiUpdateBudgetGroupRequest, params: RequestParams = {}) =>
    this.http.request<BudgetGroupResponse, any>({
      path: `/v1/budgets`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateBudgetGroupPath = '/v1/budgets'
  static updateBudgetGroupMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-budget-controller
   * @name FindBudgetByIdAndOrganisationId
   * @request GET:/api/v1/budgets/{budgetId}
   */
  findBudgetByIdAndOrganisationId = (budgetId: string, params: RequestParams = {}) =>
    this.http.request<BudgetWithSpendersAndGroupInfoAndSubBudgets, any>({
      path: `/v1/budgets/${budgetId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findBudgetByIdAndOrganisationIdPath = '/v1/budgets/${budgetId}'
  static findBudgetByIdAndOrganisationIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-budget-controller
   * @name UpdateBudgetPeriod
   * @request PUT:/api/v1/budgets/{budgetId}
   */
  updateBudgetPeriod = (
    budgetId: string,
    data: ApiUpdateBudgetPeriodRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ApiUpdateBudgetResponse, any>({
      path: `/v1/budgets/${budgetId}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateBudgetPeriodPath = '/v1/budgets/${budgetId}'
  static updateBudgetPeriodMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-budget-controller
   * @name DeleteBudgetByIdAndOrganisationId
   * @request DELETE:/api/v1/budgets/{budgetId}
   */
  deleteBudgetByIdAndOrganisationId = (budgetId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/budgets/${budgetId}`,
      method: 'DELETE',
      ...params,
    })

  static deleteBudgetByIdAndOrganisationIdPath = '/v1/budgets/${budgetId}'
  static deleteBudgetByIdAndOrganisationIdMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-budget-controller
   * @name BulkUpdateBudgetGroupsAmountType
   * @request PUT:/api/v1/budgets/groups/amount-type
   */
  bulkUpdateBudgetGroupsAmountType = (
    data: ApiBulkUpdateBudgetGroupsAmountTypeRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ApiUpdateBudgetResponse, any>({
      path: `/v1/budgets/groups/amount-type`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static bulkUpdateBudgetGroupsAmountTypePath = '/v1/budgets/groups/amount-type'
  static bulkUpdateBudgetGroupsAmountTypeMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-budget-controller
   * @name AssignToBudget
   * @request POST:/api/v1/budgets/{budgetId}/assignments
   */
  assignToBudget = (budgetId: string, data: ApiAssignmentRequest, params: RequestParams = {}) =>
    this.http.request<ApiAssignmentResponse, any>({
      path: `/v1/budgets/${budgetId}/assignments`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static assignToBudgetPath = '/v1/budgets/${budgetId}/assignments'
  static assignToBudgetMethod = 'POST'
  /**
   * No description
   *
   * @tags api-budget-controller
   * @name UnassignFromBudgetV2
   * @request DELETE:/api/v1/budgets/{budgetId}/assignments
   */
  unassignFromBudgetV2 = (
    { budgetId, ...query }: UnassignFromBudgetV2Params,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/budgets/${budgetId}/assignments`,
      method: 'DELETE',
      query: query,
      ...params,
    })

  static unassignFromBudgetV2Path = '/v1/budgets/${budgetId}/assignments'
  static unassignFromBudgetV2Method = 'DELETE'
  /**
   * No description
   *
   * @tags api-budget-controller
   * @name PagedBudgetAssignments
   * @request POST:/api/v1/budgets/{budgetId}/assignments/paged
   */
  pagedBudgetAssignments = (
    budgetId: string,
    data: ApiPagedAssignmentRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ApiPagedAssignmentResponse, any>({
      path: `/v1/budgets/${budgetId}/assignments/paged`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static pagedBudgetAssignmentsPath = '/v1/budgets/${budgetId}/assignments/paged'
  static pagedBudgetAssignmentsMethod = 'POST'
  /**
   * No description
   *
   * @tags api-budget-controller
   * @name ExportAssignmentsCsv
   * @request POST:/api/v1/budgets/{budgetId}/assignments/export/csv
   */
  exportAssignmentsCsv = (
    budgetId: string,
    data: ApiAssignmentExportCsvRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<string, any>({
      path: `/v1/budgets/${budgetId}/assignments/export/csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static exportAssignmentsCsvPath = '/v1/budgets/${budgetId}/assignments/export/csv'
  static exportAssignmentsCsvMethod = 'POST'
  /**
   * No description
   *
   * @tags api-budget-controller
   * @name PrepareBudgetPeriods
   * @request POST:/api/v1/budgets/prepare-periods
   */
  prepareBudgetPeriods = (data: ApiBudgetPeriodPrepareRequest, params: RequestParams = {}) =>
    this.http.request<BudgetPeriodResponse, any>({
      path: `/v1/budgets/prepare-periods`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static prepareBudgetPeriodsPath = '/v1/budgets/prepare-periods'
  static prepareBudgetPeriodsMethod = 'POST'
  /**
   * No description
   *
   * @tags api-budget-controller
   * @name PagedBudget
   * @request POST:/api/v1/budgets/paged
   */
  pagedBudget = (data: ApiPagedBudgetRequest, params: RequestParams = {}) =>
    this.http.request<PaginatedResponseBudgetWithSpendersBudgetPagedMeta, any>({
      path: `/v1/budgets/paged`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static pagedBudgetPath = '/v1/budgets/paged'
  static pagedBudgetMethod = 'POST'
  /**
   * No description
   *
   * @tags api-budget-controller
   * @name GetPurchaseRequestBudgetsMatchWithSpendBudgets
   * @request POST:/api/v1/budgets/matches
   */
  getPurchaseRequestBudgetsMatchWithSpendBudgets = (
    query: GetPurchaseRequestBudgetsMatchWithSpendBudgetsParams,
    data: GetPurchaseRequestBudgetsMatchWithSpendBudgetsPayload,
    params: RequestParams = {},
  ) =>
    this.http.request<ApiBudgetMatchesResponse, any>({
      path: `/v1/budgets/matches`,
      method: 'POST',
      query: query,
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getPurchaseRequestBudgetsMatchWithSpendBudgetsPath = '/v1/budgets/matches'
  static getPurchaseRequestBudgetsMatchWithSpendBudgetsMethod = 'POST'
  /**
   * No description
   *
   * @tags api-budget-controller
   * @name MigrateAssignmentModeParentModeToIncludeSplits
   * @request POST:/api/v1/budgets/enable-split-allocation
   */
  migrateAssignmentModeParentModeToIncludeSplits = (params: RequestParams = {}) =>
    this.http.request<BudgetAssignmentModeMigrationResponse, any>({
      path: `/v1/budgets/enable-split-allocation`,
      method: 'POST',
      format: 'json',
      ...params,
    })

  static migrateAssignmentModeParentModeToIncludeSplitsPath = '/v1/budgets/enable-split-allocation'
  static migrateAssignmentModeParentModeToIncludeSplitsMethod = 'POST'
  /**
   * No description
   *
   * @tags api-budget-controller
   * @name ReplaceObjectAssignments
   * @request POST:/api/v1/budgets/assignments
   */
  replaceObjectAssignments = (data: ApiBulkAssignmentRequest, params: RequestParams = {}) =>
    this.http.request<BulkAssignmentResponse, any>({
      path: `/v1/budgets/assignments`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static replaceObjectAssignmentsPath = '/v1/budgets/assignments'
  static replaceObjectAssignmentsMethod = 'POST'
  /**
   * No description
   *
   * @tags api-budget-controller
   * @name GetAllowedActions2
   * @request POST:/api/v1/budgets/allowed-actions
   */
  getAllowedActions = (data: ApiAllowedActionsRequest, params: RequestParams = {}) =>
    this.http.request<AllowedActionsResponse, any>({
      path: `/v1/budgets/allowed-actions`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getAllowedActionsPath = '/v1/budgets/allowed-actions'
  static getAllowedActionsMethod = 'POST'
  /**
   * No description
   *
   * @tags api-budget-controller
   * @name FindBudgetGroupByIdAndOrganisationId
   * @request GET:/api/v1/budgets/{budgetId}/group
   */
  findBudgetGroupByIdAndOrganisationId = (budgetId: string, params: RequestParams = {}) =>
    this.http.request<BudgetGroupResponse, any>({
      path: `/v1/budgets/${budgetId}/group`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findBudgetGroupByIdAndOrganisationIdPath = '/v1/budgets/${budgetId}/group'
  static findBudgetGroupByIdAndOrganisationIdMethod = 'GET'
  /**
   * No description
   *
   * @tags api-budget-controller
   * @name GetSettings1
   * @request GET:/api/v1/budgets/settings
   */
  getSettings = (params: RequestParams = {}) =>
    this.http.request<SettingsResponse, any>({
      path: `/v1/budgets/settings`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getSettingsPath = '/v1/budgets/settings'
  static getSettingsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-budget-controller
   * @name GetAllRecommendedBudgets
   * @request GET:/api/v1/budgets/recommended-to
   */
  getAllRecommendedBudgets = (query: GetAllRecommendedBudgetsParams, params: RequestParams = {}) =>
    this.http.request<ApiBudgetRecommendationsResponse, any>({
      path: `/v1/budgets/recommended-to`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getAllRecommendedBudgetsPath = '/v1/budgets/recommended-to'
  static getAllRecommendedBudgetsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-budget-controller
   * @name FetchBudgetsChart
   * @request GET:/api/v1/budgets/chart
   */
  fetchBudgetsChart = (query: FetchBudgetsChartParams, params: RequestParams = {}) =>
    this.http.request<BudgetsWithAssignmentAmountsResponse, any>({
      path: `/v1/budgets/chart`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static fetchBudgetsChartPath = '/v1/budgets/chart'
  static fetchBudgetsChartMethod = 'GET'
  /**
   * No description
   *
   * @tags api-budget-controller
   * @name GetMatchingBudgets
   * @request GET:/api/v1/budgets/assignments/matching
   */
  getMatchingBudgets = (query: GetMatchingBudgetsParams, params: RequestParams = {}) =>
    this.http.request<AllObjectAssignmentsResponse, any>({
      path: `/v1/budgets/assignments/matching`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getMatchingBudgetsPath = '/v1/budgets/assignments/matching'
  static getMatchingBudgetsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-budget-controller
   * @name GetAllBudgetsAssignedTo
   * @request GET:/api/v1/budgets/assignedTo
   */
  getAllBudgetsAssignedTo = (query: GetAllBudgetsAssignedToParams, params: RequestParams = {}) =>
    this.http.request<AllObjectAssignmentsResponse, any>({
      path: `/v1/budgets/assignedTo`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getAllBudgetsAssignedToPath = '/v1/budgets/assignedTo'
  static getAllBudgetsAssignedToMethod = 'GET'
}
